module.exports = __webpack_public_path__ + "img/burger_menu.db5dc532.png";